module.exports = __webpack_public_path__ + "media/images/icons/filled/dislike-f34c97a9406bd7da390b545b0ef2a617.svg";